import dayjs from 'dayjs';

const formatAge = (ageSeconds: number): string => {
    if (ageSeconds < 60) return 'less than a minute old';

    const ageMinutes = Math.floor(ageSeconds / 60);
    if (ageMinutes < 60) return `${ageMinutes} minute${ageMinutes === 1 ? '' : 's'} old`;

    const ageHours = Math.floor(ageMinutes / 60);
    if (ageHours < 48) return `${ageHours} hour${ageHours === 1 ? '' : 's'} old`;

    const ageDays = Math.floor(ageHours / 24);
    return `${ageDays} day${ageDays === 1 ? '' : 's'} old`;
};

export const formatBestBacktestSnapshotReadiness = (params: {
    oldestAvailableAtTimestamp: number | null;
    newestAvailableAtTimestamp: number | null;
    nowTimestamp: number;
}): string | null => {
    const { oldestAvailableAtTimestamp, newestAvailableAtTimestamp, nowTimestamp } = params;
    if (newestAvailableAtTimestamp === null) return null;

    const timestampLabel = dayjs.unix(newestAvailableAtTimestamp).format('MMM D, YYYY h:mm A');
    const ageLabel = formatAge(Math.max(0, nowTimestamp - newestAvailableAtTimestamp));

    if (oldestAvailableAtTimestamp === null || oldestAvailableAtTimestamp === newestAvailableAtTimestamp) {
        return `Snapshot available ${timestampLabel} (${ageLabel})`;
    }

    const oldestTimestampLabel = dayjs.unix(oldestAvailableAtTimestamp).format('MMM D, YYYY h:mm A');
    return `Snapshots available ${oldestTimestampLabel} through ${timestampLabel} (newest is ${ageLabel})`;
};

export const describeBestBacktestPreparation = (reason: string | null): string => {
    switch (reason) {
        case 'source_backtest_coverage_not_ready':
            return 'Waiting for the required historical backtests to finish.';
        case 'source_backtest_refresh_pending':
        case 'automatic_preparation_in_progress':
            return 'Updating historical results and preparing the selection data automatically.';
        case 'selection_snapshot_pending':
        case 'no_compatible_snapshot':
            return 'Preparing the selection data for this exact strategy configuration.';
        case 'one_or_more_snapshots_missing_or_stale':
            return 'Refreshing outdated selection data.';
        case 'snapshot_materialization_failed':
            return 'Selection data preparation failed. Retry the save to start a fresh attempt.';
        default:
            return 'Preparing the data required by this trading profile.';
    }
};
